<template>
  <LayoutDefault :show-side-bar="false">
    <MonitoringFilter
      @search="search"
      :monitor-mode="$route.query.monitor === 'true'"
      :legendCountPrimary="this.legendCountPrimary"
      :legendCountSuccess="this.legendCountSuccess"
      :legendCountWarning="this.legendCountWarning"
      :legendCountDanger="this.legendCountDanger"
      :legendCountSecondary="this.legendCountSecondary"/>
    <div class="row d-flex flex-fill">
      <b-overlay :show="isLoading || isLoadingStatus" class="col-lg-12 text-center">
        <h3>{{ $t('monitoramento.titulo_all') }}</h3>
        <vnsHexagonList class="m-auto" :vns-list="all" @click-right="openModal" @click-center="openJira" />
      </b-overlay>
    </div>
    <b-modal
        size="xl"
        body-class="p-0 m-0"
        hide-footer
        :title="current.name"
        @hidden="closeModal"
        v-model="modalShowing">
      <Monitor />
    </b-modal>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from "@/templates/LayoutDefault";
import Monitor from "@/pages/vns/components/Monitor";
import vnsHexagonList from "@/pages/vns/components/vnsHexagonList";
import moment from 'moment-timezone';
import {mapActions, mapGetters} from "vuex";
import {getPermissionsFromActualPerfil} from "@/acl";
import MonitoringFilter from "./MonitoringFilter";

export default {
  name: "index",
  components: {
    LayoutDefault,
    vnsHexagonList,
    Monitor,
    MonitoringFilter
  },
  computed: {
    ...mapGetters({
      current: 'vns/current',
      vns: 'vns/all',
      status: 'vns/monitor/getStatus',
      jira: 'vns/monitor/getJira',
      isLoading: 'vns/isLoading',
      isLoadingStatus: 'vns/monitor/isLoading',
      filtro: 'monitoringFilter/all'
    }),
    legendCountPrimary(){
      return this.legendCount.primary
    },
    legendCountSuccess(){
      return this.legendCount.success
    },
    legendCountWarning(){
      return this.legendCount.warning
    },
    legendCountDanger(){
      return this.legendCount.danger
    },
    legendCountSecondary(){
      return this.legendCount.secondary
    },
    automacao() {
      const list_automacao = this.vns.filter(vns => vns.integration_destination && vns.integration_destination.integration_type === 'Automation')
      return this.prepareVns(list_automacao)
    },
    display() {
      const list_link = this.vns.filter(vns => vns.integration_destination && vns.integration_destination.integration_type === 'Display')
      return this.prepareVns(list_link)
    },
    link() {
      const list_display = this.vns.filter(vns => vns.integration_destination && vns.integration_destination.integration_type === 'Link')
      return this.prepareVns(list_display)
    },
    quick() {
      const list_quick = this.vns.filter(vns => vns.integration_destination && vns.integration_destination.integration_type === 'Quick')
      return this.prepareVns(list_quick)
    },
    all() {
      this.resetLegendCount()
      const list_all = this.vns.filter(vns => vns.integration_destination)
      return this.prepareVns(list_all)
    }
  },
  data() {
    return {
      modalShowing: false,
      permissions: [],
      statusKeep: null,
      legendCount: {
        primary: 0,
        success: 0,
        warning: 0,
        danger: 0,
        secondary: 0
      }
    }
  },
  methods: {
    ...mapActions([
      'vns/listToMonitor',
      'vns/monitor/listStatusToMonitor',
      'vns/monitor/listJiraToMonitor',
      'vns/listOne',
      'monitoringFilter/setSpecific',
      'monitoringFilter/reset'
    ]),
    resetLegendCount(){
      this.legendCount = {
        primary: 0,
        success: 0,
        warning: 0,
        danger: 0,
        secondary: 0
      }
    },
    incrementLegendCountPrimary() {
      if (!this.legendCount) {
        this.legendCount.primary = 0;
        return;
      }
      this.legendCount.primary++
    },
    incrementLegendCountSuccess() {
      if (!this.legendCount) {
        this.legendCount.success = 0;
        return;
      }
      ++this.legendCount.success
    },
    incrementLegendCountWarning() {
      if (!this.legendCount) {
        this.legendCount.warning = 0;
        return;
      }
      ++this.legendCount.warning
    },
    incrementLegendCountDanger() {
      if (!this.legendCount) {
        this.legendCount.danger = 0;
        return;
      }
      ++this.legendCount.danger
    },
    incrementLegendCountSecondary() {
      if (!this.legendCount) {
        this.legendCount.secondary = 0;
        return;
      }
      ++this.legendCount.secondary
    },
    orderByVns(list) {
      return list.sort((a, b) => {
        let order = 0

        if (a.title > b.title) {
          order++
        }
        if (a.title < b.title) {
          order--
        }
        if (a.orderByStatus > b.orderByStatus) {
          order+= ((a.orderByStatus - b.orderByStatus) + 1)
        }
        if (a.orderByStatus < b.orderByStatus) {
          order+= ((a.orderByStatus - b.orderByStatus) - 1)
        }

        return order
      })
    },
    prepareVns(list) {      
      let listFiltered = list.filter(vns => {
        const hclass = this.getStatus(vns)

        if (this.filtro.status_filter != '' && this.filtro.status_filter != hclass) {
          return false;
        }
        return true
      })

      let listMaped = listFiltered.map(vns => {
        const hclass = this.getStatus(vns)
        this.countStatus(vns)
        const orderByStatus = this.getOrderByStatus(hclass);
        const icons = this.getIcons(vns)
        return {
          id: vns.id,
          title: vns.name,
          textPrimary: vns.company.name,
          textSubTitle: vns.core_care_unit.name,
          textSecondary: vns.integration_destination.name,
          hexagonClass: hclass,
          orderByStatus: orderByStatus,
          icons
        }
      })

      return this.orderByVns(listMaped);
    },
    getOrderByStatus(status) {
      if (status == 'primary') {
        return 5;
      }

      if (status == 'success') {
        return 4;
      }

      if (status == 'warning') {
        return 3;
      }

      if (status == 'danger') {
        return 1;
      }

      if (status == 'secondary') {
        return 2;
      }
    },
    countStatus(vns) {
      const status = this.status.find(s => s.vns_id === vns.id)
      const jira = this.jira.find(s => s.vns_id === vns.id)
      let ruleStatusName = this.ruleStatus(vns, status, jira);      

      if (ruleStatusName == 'primary') {
        this.incrementLegendCountPrimary();
      }

      if (ruleStatusName == 'success') {
        this.incrementLegendCountSuccess();
      }

      if (ruleStatusName == 'warning') {
        this.incrementLegendCountWarning();
      }

      if (ruleStatusName == 'danger') {
        this.incrementLegendCountDanger();
      }

      if (ruleStatusName == 'secondary') {
        this.incrementLegendCountSecondary();
      }
    },
    ruleStatus(vns, status, jira) {      
      if (status) {
        const created_at = moment(status.created_at)
        const duration = moment.duration(moment().diff(created_at))
        const diff_in_minutes = duration.asMinutes()

        if (diff_in_minutes > process.env.VUE_APP_VNS_DANGER) {
          return 'danger'
        }

        if (jira && jira.status === 1) {
          return 'secondary'
        }

        if (vns.integration_destination && vns.integration_destination.integration_type === 'Link' && !status.printer) {
          return 'warning'
        }
                
        return 'success'
      }      
      return 'primary'
    },
    getStatus(vns) {
      const status = this.status.find(s => s.vns_id === vns.id)
      const jira = this.jira.find(s => s.vns_id === vns.id)
      return this.ruleStatus(vns, status, jira);
    },
    getTypeIcon(vns) {
      if (vns.integration_destination && vns.integration_destination.integration_type === 'Link') {
        return 'print fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Automation') {
        return 'cogs fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Quick') {
        return 'camera fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'LIS') {
        return 'flask fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Display') {
        return 'desktop fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'HIS') {
        return 'hospital fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Label') {
        return 'tag fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Temp') {
        return 'thermometer-half fa-lg'
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Generic') {
        return 'globe fa-lg'
      }

      return 'question';
    },
    getTypeIconTitle(vns) {
      if (vns.integration_destination && vns.integration_destination.integration_type === 'Link') {
        return this.$t('monitoramento.tipos_integracao.impressora')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Automation') {
        return this.$t('monitoramento.tipos_integracao.automacao')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'LIS') {
        return this.$t('monitoramento.tipos_integracao.lis')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Display') {
        return this.$t('monitoramento.tipos_integracao.display')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Generic') {
        return this.$t('monitoramento.tipos_integracao.generic')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Quick') {
        return this.$t('monitoramento.tipos_integracao.quick')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'HIS') {
        return this.$t('monitoramento.tipos_integracao.his')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Label') {
        return this.$t('monitoramento.tipos_integracao.label')
      } else if (vns.integration_destination && vns.integration_destination.integration_type === 'Temp') {
        return this.$t('monitoramento.tipos_integracao.temp')
      }
      
      return this.$t('monitoramento.tipos_integracao.indefinido');
    },
    getIconJira(jira) {
      if (!jira || jira.status === 0) {
        return ''
      }

      switch (jira.type_problem) {
        case 'LAST_IP':
          return 'network-wired'
          break;
        case 'TEMPERATURE':
          return 'thermometer-half fa-lg'
          break;        
      }

      return 'exclamation'
    },
    getTitleJira(jira) {
      if (!jira || jira.status === 0) {
        return ''
      }

      switch (jira.type_problem) {
        case 'LAST_IP':
          return this.$t('monitoramento.jira.tipos_problema.ip')
          break;
        case 'TEMPERATURE':
          return this.$t('monitoramento.jira.tipos_problema.temperatura')
          break;        
      }

      return ''
    },
    getLinkJira(jira) {
      if (!jira || jira.status === 0) {
        return ''
      }

      return jira.jira_link
    },
    showIconJira(vnsStatus, jira) {
      if (!jira || jira.status === 0) {
        return false
      }

      if (vnsStatus === 'secondary' || vnsStatus === 'danger') {
        return true
      }

      return false
    },
    getIcons(vns) {
      const jira = this.jira.find(s => s.vns_id === vns.id)

      const vnsStatus = this.getStatus(vns)
      let icons = {
        left: {
          // show: this.getStatus(vns) === 'warning',
          show: false,
          span: ['bg-gradient-warning'],
          icon: 'print'
        },
        center: {
          show: this.showIconJira(vnsStatus, jira),
          span: ['bg-gradient-dark'],
          icon: this.getIconJira(jira),
          title: this.getTitleJira(jira),
          link: this.getLinkJira(jira)
        },
        right: {
          show: false,
          span: ['bg-gradient-dark'],
          icon: 'align-justify'
        },
        type: {
          icon: this.getTypeIcon(vns),
          title: this.getTypeIconTitle(vns)
        }
      }

      if (this.permissions.some(p => [
        'vns_monitor.tipo',
        'vns_monitor.tipo_info',
        'vns_monitor.tipo_latency',
        'vns_monitor.tipo_temperature',
        'vns_monitor.tipo_location',
        'vns_monitor.tipo_jira',
      ].indexOf(p) >= 0)) {
        icons.right.show = true
      }

      return icons
    },
    chunkArrayGettingIds(inputArray, itemsPerGroup = 15) {
      let tempArray = [];

      for (let idx = 0; idx < inputArray.length; idx += itemsPerGroup) {
        let chunk = inputArray.slice(idx, idx+itemsPerGroup)
            .reduce((acc, cur) => [...acc, cur.id], [])
        tempArray.push(chunk)
      }
      return tempArray
    },
    async openJira(evt) {
      window.open(evt.icons.center.link, "_blank");
    },
    async openModal(evt) {
      this.statusKeep = this.status
      await this.$store.commit('vns/setCurrent', evt)
      this['vns/listOne'](evt.id)
      this.modalShowing = true
    },
    async closeModal() {
      this.$store.commit('vns/setCurrent', {})
      this.$store.commit('vns/monitor/setIp', [])
      this.$store.commit('vns/monitor/setStatus', this.statusKeep)
      this.statusKeep = null
      this.$store.commit('vns/monitor/setSensor', [])
      this.$store.commit('vns/monitor/setLog', [])
      this.$store.commit('vns/monitor/setGeolocation', {})
    },
    search() {
      this.$store.commit('vns/setAll', [])

      let filtroApi = [];

      for (const key in this.filtro) {
        if (key === 'status' && this.filtro[key]) {
          filtroApi.push(['vns.' + key, '=', this.filtro[key]])
        }

        if (key === 'integration_type' && this.filtro[key] && this.filtro[key].length > 0) {
          filtroApi.push(['vns_integrations.integration_type', 'IN', this.filtro[key]])
        }

        if (key === 'vns_filter' && this.filtro[key]) {
          filtroApi.push(['vns.name', 'LIKE', `%${this.filtro[key]}%`])
        }

        if (key === 'company_filter' && this.filtro[key]) {
          filtroApi.push(['vns.company_id', '=', this.filtro[key]])
        }
      }

      this['vns/listToMonitor']({filters: filtroApi})
      this['vns/monitor/listStatusToMonitor']()
      this['vns/monitor/listJiraToMonitor']()
    },
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil()
  },
  async mounted() {
    await this['monitoringFilter/reset']()
    await this.$store.commit('vns/setAll', [])
    await this['vns/listToMonitor']({filters: [['vns.status', '=', true]]})
    await this['vns/monitor/listStatusToMonitor']()
    await this['vns/monitor/listJiraToMonitor']()

    this.search();

    this.timer = setInterval(() => {
      if (!this.modalShowing) {
        this['vns/monitor/listStatusToMonitor']()
        this['vns/monitor/listJiraToMonitor']()
      }
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-weight: bold;
}
</style>
